<template>
  <div v-loading="loading">
    <h3>Document Form - {{ $route.params.id ? 'Edit' : 'Create' }}</h3>
    <hr class="my-4" />
    <div id="form-container" class="pt-2">
      <el-form
        ref="elForm"
        :model="formData"
        :rules="validationRules"
        size="medium"
        label-width="auto"
      >
        <el-form-item
          label="Customer Name"
          prop="CustomerName"
          v-if="!isCustomer"
        >
          <el-select
            v-model="formData.CustomerName"
            placeholder="Select Customer"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in costumers"
              :key="index"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Description" prop="Description">
          <el-input
            v-model="formData.Description"
            placeholder="Description"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="Note" prop="Note">
          <el-input
            v-model="formData.Note"
            type="textarea"
            placeholder="Note"
            :autosize="{ minRows: 4, maxRows: 4 }"
            :style="{ width: '100%' }"
          ></el-input>
        </el-form-item>

        <hr class="my-4" />
        <div class="w-full text-right">
          <el-button type="primary" @click="submit">Submit</el-button>
          <el-button @click="cancel">Cancel</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import formService from '@/mixins/FormService'
import formHelper from './form-helper'
// import { DxButton } from 'devextreme-vue'
// import { DxForm, DxSimpleItem, DxLabel } from 'devextreme-vue/form'

let service

export default {
  components: {
    // DxButton,
    // DxForm,
    // DxSimpleItem,
    // DxLabel
  },
  created() {
    service = new formService(this, formHelper)
  },
  async mounted() {
    this.loading = true
    this.formData = await service.initialFormData()
    this.fetchCustomer()
    this.setDefaultCustomerId()

    if (this.$route.params.id) {
      this.mode = 'edit'
    }
    this.loading = false
  },
  data() {
    return {
      apiGetById: this.$appInfo.api.docs.getById,
      apiPost: this.$appInfo.api.docs.post,
      apiPut: this.$appInfo.api.docs.put,
      formData: formHelper.getEmptyData(),
      validationRules: formHelper.getValidationRule(),
      roles: [],
      costumers: [],
      mode: '',
      isSubmit: false,
      loading: false
    }
  },
  methods: {
    setDefaultCustomerId() {
      if (this.isCustomer) {
        this.formData.CustomerName = this.user.CustomerName
          ? this.user.CustomerName[0]
          : ''
      }
    },

    async cancel() {
      this.$router.go(-1)
    },
    async submit() {
      this.$refs.elForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            this.isSubmit = true
            await service.customSubmit(this.formData)
            this.$message.success('Data Saved')
            this.loading = false
          } catch (e) {
            this.loading = false
            this.$message.error(e)
            console.log(e)
          }
        } else {
          this.$message.warning('Please fill in the required data')
          this.loading = false
          return false
        }
      })
    },
    async fetchCustomer() {
      try {
        this.loading = true
        const res = await this.$axios.get(
          `${this.$appInfo.api.customer.getCustomerDropdown}`
        )
        this.costumers = res.data
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    }
  },
  computed: {
    isCustomer() {
      return this.$store.state.auth.isCustomer
    },
    user() {
      return this.$store.state.auth.userData
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isSubmit) {
      const answer = window.confirm(
        'Do you really want to leave? you have unsaved changes!'
      )
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>
